import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { FlexBetween, FlexCenter, HideScrollbar } from '../../global/commonStyle';
import React from 'react';

interface Props {
  isMinWidth?: number;
  trigger?: 'click' | 'hover' | 'contextmenu';
  isRemoveMaxHeight?: boolean;
  isDatePickerOpen?: boolean;
  openDirection?: 'top' | 'bottom';
  isRemoveTopPadding?: boolean;
  disabled?: boolean;
  top?: number;
  left?: number;
  marginTop?: number;
  isCalendarDropdown?: boolean;
  customStyle?: React.CSSProperties;
  dropdownContentWidth?: string;
}

const DropdownWrapper = styled.div<Props>`
  width: ${({ dropdownContentWidth, trigger }) => (trigger === 'contextmenu' ? '100%' : dropdownContentWidth)};
  position: relative;
  pointer-events: auto;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  .no-scroll {
    ${HideScrollbar}
  }
`;

const DropdownMenu = styled.div<Props>`
  position: absolute;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background-color: var(--background-primary);
  color: var(--text-primary);
  box-shadow: var(--shadow-dropdown);
  z-index: var(--z-index-toast);
  max-width: 198px;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-top: var(--space-4);
  ${({ top }) => top !== undefined && `top: ${top}px;`}
  ${({ left }) => left !== undefined && `left: ${left}px;`}
  ${({ isMinWidth }) => isMinWidth && `min-width: ${isMinWidth}px;`}
  ${({ isCalendarDropdown }) =>
    isCalendarDropdown &&
    css`
      max-height: 60vh;
      overflow-y: auto;
    `}
 ${({ customStyle }) =>
    customStyle &&
    Object.entries(customStyle)
      .map(([key, value]) => `${key}: ${value};`)
      .join('')}
`;

const Divider = styled.div`
  height: 0.5px;
  background-color: var(--border-primary);
  margin-block: var(--space-3);
`;

const DropHeader = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  padding: var(--space-6) var(--space-14) var(--space-6) var(--space-10);
`;

const ResponsiveModalMainDiv = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--modal-background-overlay);
  backdrop-filter: blur(20px);
  display: flex;
  padding-inline: var(--space-20);
  z-index: var(--z-index-toast);
`;

const ResponsiveDropdownMenu = styled.div`
  margin: auto;
  background: var(--background-primary);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  border-radius: var(--border-radius-12);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  z-index: var(--z-index-toast);
  position: relative;
`;

const ModalTitle = styled.p`
  margin: var(--space-0);
  ${Typography.body_lg_semibold}
  color: var(--text-secondary);
`;

const ModalHeader = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-12) var(--space-2);
  margin: var(--space-8) var(--space-0) var(--space-0) var(--space-10);
  .icon-button {
    background: var(--neutral-secondary);
  }
`;

const ResponsiveSearchInput = styled.div`
  position: relative;
`;

const Icon = styled.div`
  position: absolute;
  z-index: var(--z-index-11);
  top: 12px;
  left: 22px;
  width: 18px;
  height: 18px;
  ${FlexCenter}
`;

const ItemList = styled.div<Props>`
  ${HideScrollbar}
  max-height: 189px;
  padding-block: var(--space-4);
  ${mobile_xl(css`
    max-height: 286px;
    padding-block: var(--space-4) var(--space-8);
  `)};
  ${(props) =>
    props.isRemoveMaxHeight &&
    css`
      max-height: unset;
      overflow: unset;
      ${mobile_xl(css`
        max-height: unset;
        overflow: unset;
      `)}
    `}
  ${(props) =>
    props.isDatePickerOpen &&
    css`
      overflow: unset;
    `};
  ${(props: Props) =>
    props.isRemoveTopPadding &&
    css`
      padding: var(--space-0) var(--space-0) var(--space-4) var(--space-0);
    `}
`;

export {
  DropdownMenu,
  DropdownWrapper,
  Divider,
  DropHeader,
  ModalHeader,
  ModalTitle,
  ResponsiveDropdownMenu,
  ResponsiveModalMainDiv,
  Icon,
  ResponsiveSearchInput,
  ItemList
};
